<template>
  <div :class="sidebarbg" class="app-sidebar sidebar-shadow">
    <div class="app-sidebar-content">
      <VuePerfectScrollbar tabindex="-1" class="app-sidebar-scroll left-sidebar-menu" >
        <div class="sidebar-top-bar">
          <div class="sidebar-top-bar-btngroup">
            메뉴 바로가기
          </div>
          <div class="sidebar-top-bar-close">
            <q-btn flat color="gray" icon="close" @click="toggleMobile('closed-sidebar-open')" />
          </div>
        </div>
        <c-sidebar-menu showOneChild :menu="permission_routers" />
      </VuePerfectScrollbar>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import transactionConfig from '@/js/transactionConfig';
import { mapGetters } from 'vuex'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    sidebarbg: String
  },
  data() {
    return {
      isOpen: false,
      sidebarActive: false,
      collapsed: true,
      windowWidth: 0,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '100%',
        isFull: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      'permission_routers',
    ]),
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);

      //Init
      this.getWindowWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  methods: {
    toggleMobile(className) {
      const el = document.body;
      el.classList.remove(className);
    },
    // toggleSidebarHover(add, className) {
      // const el = document.body;
      // this.sidebarActive = !this.sidebarActive;

      // this.windowWidth = document.documentElement.clientWidth;

      // if (this.windowWidth > "992") {
      //   if (add === "add") {
      //     el.classList.add(className);
      //   } else {
      //     el.classList.remove(className);
      //   }
      // }
    // },
    getWindowWidth() {
      const el = document.body;

      this.windowWidth = document.documentElement.clientWidth;

      if (this.windowWidth < "3800") {
        el.classList.add("closed-sidebar", "closed-sidebar-md");
      }
    },
    logout() {   
      this.$http.url = transactionConfig.auth.login.logout.url;
      this.$http.type = 'POST';
      this.$http.request(
        this.$store.dispatch('LogOut').then(() => {
          window.sessionStorage.removeItem('defaultPlantCd');
          location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
        })
      );
    },
  },
};
</script>
<style lang="sass">
.leftMenuUserArea
  // margin-bottom: 20px !important
  position: fixed
  bottom: 0
  left: 0
  right: 0
  height: 45px
  background: white
  // border-top: solid 2px #FFC107
  .logoutLink
    font-weight: 700
    font-size: 1.4em
    // display: block
    // line-height: 2.2rem
    // height: 2.2rem
    height: 100%
    // padding: 0.1rem 1.2rem 0 1.6rem
    padding: 0 !important
    position: relative
    border-radius: 0
    color: red !important
    white-space: nowrap
    -webkit-transition: all 0.2s
    transition: all 0.2s
    text-decoration: none
    text-align: center
    button
      border-radius: 0 !important

.close-menu
  position: fixed
  right: 20px
  top: 60px
</style>
